<template>
  <div>
    <BaseModalSmall
      v-if="showSubscriptionConfirmation"
      @close="showSubscriptionConfirmation = false"
    >
      <BaseText size="l">
        {{ $t('treatwell.landing.no_subscription.message', brandName()) }}
      </BaseText>
      <template #footer>
        <BaseButton
          color="inverted"
          @click="showSubscriptionConfirmation = false"
          v-test="'btn-tw-subscription-cancel'"
        >
          {{ $t('global.actions.cancel') }}
        </BaseButton>
        <BaseButton
          @click="onSubscriptionClick"
          v-test="'btn-tw-subscription-submit'"
        >
          {{ $t('treatwell.landing.no_subscription.button') }}
        </BaseButton>
      </template>
    </BaseModalSmall>
    <BaseButton
      :fullWidth="$screen === 's'"
      :loading="loading"
      @click="onStartClick"
      v-test="'btn-treatwell-start'"
      v-intercom="'treatwell-landing-start'"
    >
      {{ $t('treatwell.landing.button_start') }}
    </BaseButton>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { useMutation } from '@vue/apollo-composable';
import { useStorage } from '@vueuse/core';
import gql from 'graphql-tag';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { brandName } from '@/helpers/brand-name';
import { useCompanyStore } from '@/stores/company';
import { useTreatwellStore } from '@/stores/treatwell';

const router = useRouter();

const showSubscriptionConfirmation = ref(false);
const { isTrial } = useCompanyStore();

const { treatwellStatus } = useTreatwellStore();

const { mutate, loading } = useMutation(
  gql`
    mutation treatwellIntegrationRequestCreate(
      $input: IntegrationRequestCreateInput!
    ) {
      treatwellIntegrationRequestCreate(input: $input) {
        treatwellIntegrationRequest {
          id
        }
      }
    }
  `,
  {
    variables: {
      input: {},
    },
  },
);

const onStartClick = () => {
  if (isTrial) {
    showSubscriptionConfirmation.value = true;
  } else {
    const tw_linked_account_at = useStorage('tw_linked_account_at', 0);
    tw_linked_account_at.value = Date.now();
    if (!treatwellStatus.hasRequest) {
      mutate().then(() => {
        treatwellStatus.hasRequest = true;
        router.push({ name: 'treatwell-admin' });
      });
    } else {
      router.push({ name: 'treatwell-admin' });
    }
  }
};

const onSubscriptionClick = () => {
  showSubscriptionConfirmation.value = false;
  router.push({ name: 'subscription' });
};
</script>
